import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CriticalAlertCard = ({ alert, currentLanguage = 'fr', onAction }) => {
  const severityConfig = {
    critical: {
      icon: 'AlertTriangle',
      color: 'text-error',
      bgColor: 'bg-error/10',
      borderColor: 'border-error/30'
    },
    warning: {
      icon: 'AlertCircle',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning/30'
    },
    info: {
      icon: 'Info',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      borderColor: 'border-primary/30'
    }
  };

  const config = severityConfig?.[alert?.severity] || severityConfig?.info;

  return (
    <div className={`bg-card rounded-lg border-2 ${config?.borderColor} p-4 md:p-5 shadow-warm`}>
      <div className="flex gap-3 md:gap-4">
        <div className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full ${config?.bgColor} flex items-center justify-center`}>
          <Icon name={config?.icon} size={20} className={config?.color} />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm md:text-base font-semibold text-foreground mb-2">
            {alert?.title}
          </h4>
          <p className="caption text-muted-foreground mb-3 line-clamp-2">
            {alert?.description}
          </p>
          <div className="flex flex-col sm:flex-row gap-2">
            <Button 
              variant="default" 
              size="sm"
              iconName="ArrowRight"
              iconPosition="right"
              onClick={() => onAction?.(alert?.id)}
            >
              {alert?.actionLabel}
            </Button>
            {alert?.secondaryActionLabel && (
              <Button 
                variant="outline" 
                size="sm"
              >
                {alert?.secondaryActionLabel}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CriticalAlertCard;